import * as req from 'api/actions';
import { GET_BUSINESS_LINE, GET_REPORT_ACCESS } from '../constants';

export const setModal = (data = {}) => ({
  type: 'SET_MODAL',
  data,
});

export const startLoading = (x, z = 'loader') => ({
  ...x,
  loading: x.loading.concat([z]),
});

export const endLoading = (x, z = 'loader') => ({
  ...x,
  loading: x.loading.filter((y) => y !== z),
});

export const getCms = () =>
  req.list(
    'CMS',
    '/api/v1/taxpayers/cms' // site api ep
  );

export const getBusinessLine = (payload = {}, callback) =>
  req.list(
    GET_BUSINESS_LINE,
    `/api/v1/bpls/administrator/common/business_lines`,
    payload,
    callback
  );

export const getReportAccess = (payload, callback) =>
  req.create(
    GET_REPORT_ACCESS,
    '/api/v1/administrators/report_access_tokens',
    payload,
    callback
  );
